// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { FileCommentMessageDatagramBuf } from '../datagram/file-comment-message-datagram-buf.js';
import { ConversationCloseMessageDatagramBuf } from '../message/conversation-close-message-datagram-buf.js';
import { ConversationCreateMessageDatagramBuf } from '../message/conversation-create-message-datagram-buf.js';
import { ConversationDeleteMessageDatagramBuf } from '../message/conversation-delete-message-datagram-buf.js';
import { ConversationTurnMessageDatagramBuf } from '../message/conversation-turn-message-datagram-buf.js';
import { ConversationUpdateMessageDatagramBuf } from '../message/conversation-update-message-datagram-buf.js';
import { FileCopyMessageDatagramBuf } from '../message/file-copy-message-datagram-buf.js';
import { FileCreateMessageDatagramBuf } from '../message/file-create-message-datagram-buf.js';
import { FileDeleteMessageDatagramBuf } from '../message/file-delete-message-datagram-buf.js';
import { FileEditMessageDatagramBuf } from '../message/file-edit-message-datagram-buf.js';
import { FileHistoryMessageDatagramBuf } from '../message/file-history-message-datagram-buf.js';
import { FileMoveMessageDatagramBuf } from '../message/file-move-message-datagram-buf.js';
import { FileShareMessageDatagramBuf } from '../message/file-share-message-datagram-buf.js';
import { FileUpdateMessageDatagramBuf } from '../message/file-update-message-datagram-buf.js';
import { FilesSharedWithSelfMessageDatagramBuf } from '../message/files-shared-with-self-message-datagram-buf.js';
import { FolderListPageMessageDatagramBuf } from '../message/folder-list-page-message-datagram-buf.js';
import { SearchUpdateMessageDatagramBuf } from '../message/search-update-message-datagram-buf.js';
import { SelfUpdateMessageDatagramBuf } from '../message/self-update-message-datagram-buf.js';
import { SharedDriveCreateMessageDatagramBuf } from '../message/shared-drive-create-message-datagram-buf.js';
import { SharedDriveDeleteMessageDatagramBuf } from '../message/shared-drive-delete-message-datagram-buf.js';
import { SharedDriveMembershipMessageDatagramBuf } from '../message/shared-drive-membership-message-datagram-buf.js';
import { SharedDriveWatchMessageDatagramBuf } from '../message/shared-drive-watch-message-datagram-buf.js';
import { UserDisconnectMessageDatagramBuf } from '../message/user-disconnect-message-datagram-buf.js';
import { UserLogoutMessageDatagramBuf } from '../message/user-logout-message-datagram-buf.js';


export class MessageDatagramBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):MessageDatagramBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMessageDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:MessageDatagramBuf):MessageDatagramBuf {
  return (obj || new MessageDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMessageDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:MessageDatagramBuf):MessageDatagramBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new MessageDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

conversationCloseMessage(obj?:ConversationCloseMessageDatagramBuf):ConversationCloseMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new ConversationCloseMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationCreateMessage(obj?:ConversationCreateMessageDatagramBuf):ConversationCreateMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new ConversationCreateMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationTurnMessage(obj?:ConversationTurnMessageDatagramBuf):ConversationTurnMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new ConversationTurnMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileCopyMessage(obj?:FileCopyMessageDatagramBuf):FileCopyMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new FileCopyMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileCreateMessage(obj?:FileCreateMessageDatagramBuf):FileCreateMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new FileCreateMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileDeleteMessage(obj?:FileDeleteMessageDatagramBuf):FileDeleteMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new FileDeleteMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileEditMessage(obj?:FileEditMessageDatagramBuf):FileEditMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new FileEditMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileHistoryMessage(obj?:FileHistoryMessageDatagramBuf):FileHistoryMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new FileHistoryMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileMoveMessage(obj?:FileMoveMessageDatagramBuf):FileMoveMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new FileMoveMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileShareMessage(obj?:FileShareMessageDatagramBuf):FileShareMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new FileShareMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileUpdateMessage(obj?:FileUpdateMessageDatagramBuf):FileUpdateMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new FileUpdateMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

filesSharedWithSelfMessage(obj?:FilesSharedWithSelfMessageDatagramBuf):FilesSharedWithSelfMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? (obj || new FilesSharedWithSelfMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

folderListPageMessage(obj?:FolderListPageMessageDatagramBuf):FolderListPageMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? (obj || new FolderListPageMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfUpdateMessage(obj?:SelfUpdateMessageDatagramBuf):SelfUpdateMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? (obj || new SelfUpdateMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedDriveCreateMessage(obj?:SharedDriveCreateMessageDatagramBuf):SharedDriveCreateMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? (obj || new SharedDriveCreateMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedDriveDeleteMessage(obj?:SharedDriveDeleteMessageDatagramBuf):SharedDriveDeleteMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? (obj || new SharedDriveDeleteMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedDriveMembershipMessage(obj?:SharedDriveMembershipMessageDatagramBuf):SharedDriveMembershipMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 36);
  return offset ? (obj || new SharedDriveMembershipMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

searchUpdateMessage(obj?:SearchUpdateMessageDatagramBuf):SearchUpdateMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? (obj || new SearchUpdateMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

userLogoutMessage(obj?:UserLogoutMessageDatagramBuf):UserLogoutMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? (obj || new UserLogoutMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

userDisconnectMessage(obj?:UserDisconnectMessageDatagramBuf):UserDisconnectMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? (obj || new UserDisconnectMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationUpdateMessage(obj?:ConversationUpdateMessageDatagramBuf):ConversationUpdateMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 44);
  return offset ? (obj || new ConversationUpdateMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationDeleteMessage(obj?:ConversationDeleteMessageDatagramBuf):ConversationDeleteMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 46);
  return offset ? (obj || new ConversationDeleteMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedDriveWatchMessage(obj?:SharedDriveWatchMessageDatagramBuf):SharedDriveWatchMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 48);
  return offset ? (obj || new SharedDriveWatchMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileCommentMessage(obj?:FileCommentMessageDatagramBuf):FileCommentMessageDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 50);
  return offset ? (obj || new FileCommentMessageDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startMessageDatagramBuf(builder:flatbuffers.Builder) {
  builder.startObject(24);
}

static addConversationCloseMessage(builder:flatbuffers.Builder, conversationCloseMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, conversationCloseMessageOffset, 0);
}

static addConversationCreateMessage(builder:flatbuffers.Builder, conversationCreateMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, conversationCreateMessageOffset, 0);
}

static addConversationTurnMessage(builder:flatbuffers.Builder, conversationTurnMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, conversationTurnMessageOffset, 0);
}

static addFileCopyMessage(builder:flatbuffers.Builder, fileCopyMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, fileCopyMessageOffset, 0);
}

static addFileCreateMessage(builder:flatbuffers.Builder, fileCreateMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, fileCreateMessageOffset, 0);
}

static addFileDeleteMessage(builder:flatbuffers.Builder, fileDeleteMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, fileDeleteMessageOffset, 0);
}

static addFileEditMessage(builder:flatbuffers.Builder, fileEditMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, fileEditMessageOffset, 0);
}

static addFileHistoryMessage(builder:flatbuffers.Builder, fileHistoryMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, fileHistoryMessageOffset, 0);
}

static addFileMoveMessage(builder:flatbuffers.Builder, fileMoveMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, fileMoveMessageOffset, 0);
}

static addFileShareMessage(builder:flatbuffers.Builder, fileShareMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, fileShareMessageOffset, 0);
}

static addFileUpdateMessage(builder:flatbuffers.Builder, fileUpdateMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, fileUpdateMessageOffset, 0);
}

static addFilesSharedWithSelfMessage(builder:flatbuffers.Builder, filesSharedWithSelfMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(11, filesSharedWithSelfMessageOffset, 0);
}

static addFolderListPageMessage(builder:flatbuffers.Builder, folderListPageMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(12, folderListPageMessageOffset, 0);
}

static addSelfUpdateMessage(builder:flatbuffers.Builder, selfUpdateMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(13, selfUpdateMessageOffset, 0);
}

static addSharedDriveCreateMessage(builder:flatbuffers.Builder, sharedDriveCreateMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(14, sharedDriveCreateMessageOffset, 0);
}

static addSharedDriveDeleteMessage(builder:flatbuffers.Builder, sharedDriveDeleteMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(15, sharedDriveDeleteMessageOffset, 0);
}

static addSharedDriveMembershipMessage(builder:flatbuffers.Builder, sharedDriveMembershipMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(16, sharedDriveMembershipMessageOffset, 0);
}

static addSearchUpdateMessage(builder:flatbuffers.Builder, searchUpdateMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(17, searchUpdateMessageOffset, 0);
}

static addUserLogoutMessage(builder:flatbuffers.Builder, userLogoutMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(18, userLogoutMessageOffset, 0);
}

static addUserDisconnectMessage(builder:flatbuffers.Builder, userDisconnectMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(19, userDisconnectMessageOffset, 0);
}

static addConversationUpdateMessage(builder:flatbuffers.Builder, conversationUpdateMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(20, conversationUpdateMessageOffset, 0);
}

static addConversationDeleteMessage(builder:flatbuffers.Builder, conversationDeleteMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(21, conversationDeleteMessageOffset, 0);
}

static addSharedDriveWatchMessage(builder:flatbuffers.Builder, sharedDriveWatchMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(22, sharedDriveWatchMessageOffset, 0);
}

static addFileCommentMessage(builder:flatbuffers.Builder, fileCommentMessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(23, fileCommentMessageOffset, 0);
}

static endMessageDatagramBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
